import { GlobalSetting } from './../../../../../../Autofacets-Core/src/app/common-services/global-setting.service';
import { UtilityServices } from './../../../Services/utility.services';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-page-not-found',
  templateUrl: './page-not-found.component.html',
  //styleUrls: ['./page-not-found.component.css']
})
export class PageNotFoundComponent implements OnInit {

  licensePlateClass:string;
  message:string;
  constructor(
    private readonly utilityService: UtilityServices,
    private globalSetting:GlobalSetting
  ) { }

  moveNext() {
    this.utilityService.navigateToNext('/login');

  }

  ngOnInit(): void {
    this.licensePlateClass=this.globalSetting.getGlobalLicencePlate();
    this.message = this.utilityService.pageNotFoundMessage;
  }

}
